<template>
    <div>
        <v-row>
            <v-col cols="12" md="4">
                <v-select
                    v-model="query['searchKey']"
                    v-bind="{
                        ...attrs_select_common,
                        items: searchKeys,
                        class: 'v-input--density-default rounded-0',
                        filled: true,
                    }"
                >
                    <template #append>
                        <icon-arrow-secondary size="xx-large" direction="down" class="grey--text text--darken-4" />
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12" md="8" class="mt-n12px mt-md-0">
                <v-text-field
                    v-model="query['searchValue']"
                    v-bind="{
                        ...attrs_input_common,
                        placeholder: '검색어를 입력하세요.',
                        class: 'v-input--density-default',
                    }"
                    filled
                    class="rounded-0"
                    @keydown.enter="emit"
                >
                    <template #append>
                        <v-btn icon large color="grey darken-4" class="v-btn--none-active-bg ma-n10px" @click="emit">
                            <icon-search />
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { attrs_input_common, attrs_select_common } from "@/assets/variables";

import TextFieldPrimary from "@/components/publish/parents/forms/text-field-primary.vue";
import IconSearch from "@/components/publish/styles/icons/icon-search.vue";
import IconArrowSecondary from "@/components/publish/parents/icons/icon-arrow-secondary.vue";

let searchKeys = [
    { text: "제목", value: null },
    // { text: "제목 + 내용", value: null },
];

let initQuery = (query = {}) => ({
    ...(query || {}),

    ["searchKey"]: query?.["searchKey"] || null,
    ["searchValue"]: query?.["searchValue"] || null,
});
export default {
    components: {
        TextFieldPrimary,
        IconSearch,
        IconArrowSecondary,
    },

    data: () => ({
        query: initQuery(),
        searchKeys,
        attrs_input_common,
        attrs_select_common,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query["page"];

            if (!query["searchKey"]) delete query["searchKey"];
            if (!query["searchValue"]) {
                delete query["searchKey"];
                delete query["searchValue"];
            }

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
